export class UserModel {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  birth_date?: Date;
  avatar?: string;
  has_password: boolean;
  is_doctor: boolean;
  user_type: string;
  clinic?: any;
}
